export default __webpack_public_path__ + "static/media/mn_tea_sub_6.4849e56b.png";